import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customer", "site"]

  connect() {
    this.captureSiteOptions()
    this.filterSites()
  }

  filterSites() {
    const customerId = this.customerTarget.value
    const currentValue = this.siteTarget.value
    let currentValueStillVisible = false

    this.siteOptions.forEach((option) => {
      if (option.value === "") {
        option.hidden = false
        option.disabled = false
        return
      }

      const visible = customerId !== "" && option.dataset.customerId === customerId
      option.hidden = !visible
      option.disabled = !visible
      currentValueStillVisible ||= visible && option.value === currentValue
    })

    if (!currentValueStillVisible) {
      this.siteTarget.value = ""
    }
  }

  captureSiteOptions() {
    this.siteOptions = Array.from(this.siteTarget.options)
  }
}
